import React from 'react';
const IconAlertInfoFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22ZM13 17H11V11H13V17ZM12 6.75C12.69 6.75 13.25 7.31 13.25 8C13.25 8.69 12.69 9.25 12 9.25C11.31 9.25 10.75 8.69 10.75 8C10.75 7.31 11.31 6.75 12 6.75Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconAlertInfoFill;